module.exports = __webpack_public_path__ + "img/side-icon-21.c9c29f87.svg";